import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';

import { VoiceSettings } from './types';

export interface UpdateParams {
  callRouting?: boolean;
  recordInbound?: boolean;
  recordOutbound?: boolean;
  callMaskingOutbound?: boolean;
}

type Response<T> = Promise<AxiosResponse<T>>;

export default class VoiceSettingsApi {
  static show(): Response<VoiceSettings> {
    return RestAPI.getWithQueryString<VoiceSettings>('/alpha/voice/voice_settings');
  }

  static update({
    callRouting,
    recordInbound,
    recordOutbound,
    callMaskingOutbound,
  }: UpdateParams): Response<VoiceSettings> {
    return RestAPI.updateWithFormData('/alpha/voice/voice_settings', {
      call_routing: callRouting,
      record_inbound: recordInbound,
      record_outbound: recordOutbound,
      call_masking_outbound: callMaskingOutbound,
    });
  }
}
